import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import "bootstrap-daterangepicker/daterangepicker.css"; // Import Date Range Picker CSS
import "bootstrap-daterangepicker"; // Import Date Range Picker JS
import moment from "moment";
import ContentHeader from "../../../Components/ContentHeader/ContentHeader";
import Form from "../../../Components/Form/Form";
function CreateAuditsFormExtrasUi({ formik, id ,toast}) {
  return (
    <div className="content-wrapper" style={{ minHeight: "100vh" }}>
      {/* Content Header */}
      <ContentHeader
        title={id ? "Update Audit Extras" : "Create Audit Extras"}
        buttonName={""}
        buttonBoolean={false}
        pageName={id ? "Update Audit Extras" : "Create Audit Extras"}
        backButton={true}
      />
      <div style={{ padding: "0.8rem" }}>
      <Form formik={formik} toast={toast}>
        <div className="form-group">
          <label htmlFor="title"> Title</label>
          <input
            type="text"
            name="title"
            className={`form-control ${
              formik.errors.title && formik.touched.title ? "is-invalid" : ""
            }`}
            id="title"
            placeholder="Enter Title"
            {...formik.getFieldProps("title")}
          />
          {formik.errors.title && formik.touched.title && (
            <span className="invalid-feedback">{formik.errors.title}</span>
          )}
        </div>
        <div className="form-grid">
          <div className="form-group mt-4">
            {/* <label htmlFor="mandatory">Mandatory</label> */}
            <div className="form-check">
              <input
                id="phone_number"
                className="form-check-input form-control"
                type="checkbox"
                // disabled={disabled}
                // {...formik.getFieldProps("mandatory")}
                checked={formik.values.phone_number} // Bind to Formik's value
                onChange={
                  (e) => formik.setFieldValue("phone_number", e.target.checked) // Update value based on 'checked'
                }
              />
              <label className="form-check-label">Phone Number</label>
            </div>
            {formik.errors.phone_number && formik.touched.phone_number && (
              <span className="invalid-feedback">
                {formik.errors.phone_number}
              </span>
            )}
          </div>
          <div className="form-group mt-4">
            {/* <label htmlFor="multiline">Multiline</label> */}
            <div className="form-check">
              <input
                id="designation"
                className="form-check-input form-control"
                type="checkbox"
                // {...formik.getFieldProps("multiline")}
                checked={formik.values.designation} // Bind to Formik's value
                onChange={
                  (e) => formik.setFieldValue("designation", e.target.checked) // Update value based on 'checked'
                }
              />
              <label className="form-check-label">Designation</label>
            </div>
            {formik.errors.designation && formik.touched.designation && (
              <span className="invalid-feedback">
                {formik.errors.designation}
              </span>
            )}
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="description">Description</label>
          <input
            type="text"
            name="description"
            className={`form-control ${
              formik.errors.description && formik.touched.description ? "is-invalid" : ""
            }`}
            id="answer"
            placeholder="Enter Description"
            {...formik.getFieldProps("description")}
          />
          {formik.errors.description && formik.touched.description && (
            <span className="invalid-feedback">{formik.errors.description}</span>
          )}
        </div>
      </Form>
      </div>
    </div>
  );
}

export default CreateAuditsFormExtrasUi;
